import * as x from '../helpers/xmlHelpers';

export class PropertyValuationDetail {
    constructor(doc)
    {
		this.label = null
		this.propertyValuationMethodType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.propertyValuationMethodType = x.getStringElement(doc, "./ns:PropertyValuationMethodType");
   }
}

export class PropertyValuation {
    constructor(doc)
    {
		this.label = null
		this.propertyValuationDetail = null
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:PROPERTY_VALUATION_DETAIL");
		if (node !== null)
				this.propertyValuationDetail = new PropertyValuationDetail(node);
   }
}
